import * as React from "react";
import LoginPopup from "../generic/loginPopup";
import "../../../assets/scss/components/login/loginScreen/tncConsentScreen.scss";
import EdButton from "../../generic/edButton";
import logo from "../../../assets/images/logo_white.jpg";

export interface ITncConsentScreenProps {
	disableButton: boolean;
	onButtonClick: (save: boolean) => void;
	onClose: () => void;
}

const TncConsentScreen: React.FC<ITncConsentScreenProps> = (props) => {
	return (
		<LoginPopup centerHeaderContent={<img src={logo} alt="nuvama" className="nuvama_logo"/>} onClose={props.onClose} className="change_pw_scrn">
			<section className="tnc_cnsnt_screen">
				<div className="cont">
					<div className="logo mg-b15 mg-t10"></div>
					<h1 className="comp_name">trendline</h1>

					<p className="text">
						Before proceeding please note that Nuvama will share the following details with the application mentioned above. Please
						review the same carefully before continuing.
					</p>

					<ul className="list">
						<li className="mg-b20">
							<span>Order details (including Order Book, Trade Book, Positions, Holdings)</span>
						</li>
						<li className="mg-b20">
							<span>Fund Transfer details (including any Fund additions or withdrawals and status)</span>
						</li>
						<li>
							<span>Limits and Margin availability details</span>
						</li>
					</ul>

					<div className="btn_cont">
						<EdButton value="Decline" btnTyp="secondary" className="mg-r20 tnc_btn" onClick={() => props.onButtonClick(false)} />
						<EdButton value="Accept" btnTyp="primary" className="tnc_btn" onClick={() => props.onButtonClick(true)} />
					</div>
				</div>
			</section>
		</LoginPopup>
	);
};

export default TncConsentScreen;
